export default __webpack_public_path__ + "static/media/Sameer Misbah.f19878d7.pdf";